import { AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { katex } from '../../../shared/utils/katex-loader.util';

@Component({
  selector: 'app-grading-rich-content',
  standalone: true,
  imports: [CommonModule],
  template: `<div #content class="grading-rich-content__content"></div>`,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `],
})
export class GradingRichContentComponent implements AfterViewInit, OnChanges {
  @Input() html = '';
  @ViewChild('content', { static: true }) private contentRef?: ElementRef<HTMLElement>;

  ngAfterViewInit(): void {
    this.render();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['html']) {
      this.render();
    }
  }

  private render(): void {
    const element = this.contentRef?.nativeElement;
    if (!element) {
      return;
    }

    element.innerHTML = this.html ?? '';

    const formulaNodes = element.querySelectorAll<HTMLElement>('.ql-formula[data-value]');
    formulaNodes.forEach((node) => {
      const latex = node.getAttribute('data-value');
      if (!latex) {
        return;
      }

      try {
        katex.render(latex, node, {
          displayMode: false,
          throwOnError: false,
          errorColor: '#dc3545',
        });

        const mathMlLayer = node.querySelector<HTMLElement>('.katex-mathml');
        if (mathMlLayer) {
          mathMlLayer.style.border = '0';
          mathMlLayer.style.clip = 'rect(1px, 1px, 1px, 1px)';
          mathMlLayer.style.clipPath = 'inset(50%)';
          mathMlLayer.style.height = '1px';
          mathMlLayer.style.margin = '0';
          mathMlLayer.style.overflow = 'hidden';
          mathMlLayer.style.padding = '0';
          mathMlLayer.style.position = 'absolute';
          mathMlLayer.style.whiteSpace = 'nowrap';
          mathMlLayer.style.width = '1px';
        }

        const htmlLayer = node.querySelector<HTMLElement>('.katex-html');
        if (htmlLayer) {
          htmlLayer.style.display = 'inline-block';
          htmlLayer.style.position = 'relative';
        }
      } catch {
        node.textContent = latex;
      }
    });
  }
}
